var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-the-alerts"},[_c('MoleculeTheAlerts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }